const STATUS_STYLES = {
  new: "bg-sky-100 text-sky-800 border-sky-200",
  action_needed: "bg-amber-100 text-amber-800 border-amber-200",
  waiting_customer: "bg-violet-100 text-violet-800 border-violet-200",
  waiting_internal: "bg-slate-100 text-slate-700 border-slate-200",
  closed: "bg-emerald-100 text-emerald-800 border-emerald-200",
};

const STATUS_LABELS = {
  new: "Nieuw",
  action_needed: "Actie nodig",
  waiting_customer: "Wacht op klant",
  waiting_internal: "Wacht intern",
  closed: "Gesloten",
};

export default function CommunicationStatusBadge({ status }) {
  const key = String(status || "new").trim().toLowerCase();
  const className = STATUS_STYLES[key] || STATUS_STYLES.new;
  const label = STATUS_LABELS[key] || key || "Nieuw";

  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-medium ${className}`}>
      {label}
    </span>
  );
}
